import React from 'react';
import { CopyOutlined } from '@ant-design/icons';

import { Notification } from 'redpoints-front-components/index';

import { translate } from './languageHelper';

const SUCCESS = 'successful';
const FAILURE = 'failure';

const copyToClipboard = string => {
  const tempInput = document.createElement('textarea');
  tempInput.value = string;
  document.body.appendChild(tempInput);
  tempInput.select();

  try {
    const msg = document.execCommand('copy') ? SUCCESS : FAILURE;
    if (msg !== SUCCESS) {
      throw new Error(`${translate('common.copyFailed')} ${msg}`);
    } else {
      Notification.success({
        message: translate('common.templateCopied'),
      });
    }
  } catch (err) {
    console.error(err); // eslint-disable-line
  }
  tempInput.remove();
};

export const TextWithCopyIcon = ({ text }) => {
  if (text) {
    return (
      <span>
        <span>{text}</span>
        <CopyOutlined
          onClick={() => copyToClipboard(text)}
          className="copy-to-clipboard-icon"
        />
      </span>
    );
  }

  return null;
};
